import React, { useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

export default function DialogGenReport({ dialog, setDialog, setExport, pdf, excel, word, setHeader = "พิมพ์รายงาน" }) {
    const toast = useRef(null);

    const onClose = () => {
        setDialog({ dialog: false, show: true });
    };

    return (
        <>
            <Dialog header={setHeader} visible={dialog.dialog} style={{ width: "70vw" }} 
            className="p-fluid ___widthDialog" onHide={() => onClose()} blockScroll={true} 
            maximizable={false}>
                <Toast ref={toast} position="top-right" />
                <div className="p-grid crud-demo" style={{ marginTop: 10 }}>
                    <div className="p-col-12">
                        <div className="p-grid p-fluid media-demo">
                            <div className="p-col-12">
                                <div className="p-grid  p-fluid" style={{ textAlign: "center" }}>
                                    <div className="p-col-12 p-md-12">
                                        {pdf && pdf === true && <Button className="p-button-danger p-button" icon="fa fa-file-pdf" label="พิมพ์รายงาน (PDF)" style={{ width: 170 }} onClick={() => setExport("PDF")} />}
                                        {excel && excel === true && <Button className="p-button-success p-button" icon="fa fa-file-excel" label="พิมพ์รายงาน (Excel)" style={{ width: 170, marginLeft: "5px" }} onClick={() => setExport("EXCEL")} />}
                                        {word && word === true && <Button className="p-button-info p-button" icon="fa fa-file-word" label="พิมพ์รายงาน (Word)" style={{ width: 170, marginLeft: "5px" }} onClick={() => setExport("WORD")} />}
                                        <Button className="p-button-danger p-button" icon="pi pi-ban" label="ปิดหน้าจอ" style={{ width: 170, marginLeft: "5px" }} onClick={() => onClose()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
